export default "__VITE_ASSET__JjVXhccE__"